import { mergeAttributes, Node } from "@tiptap/core";

const LegacyVideo = Node.create({
  name: "legacyVideo",

  group: "block",
  atom: true,
  draggable: true,

  addOptions() {
    return {
      HTMLAttributes: {
        allowfullscreen: "true",
        class: "ql-video",
        frameborder: "0",
      },
    };
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      title: {
        default: null,
      },
      width: {
        default: null,
      },
      height: {
        default: null,
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "iframe[src]",
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return ["iframe", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
  },

  addCommands() {
    return {
      setVideo:
        (attributes) =>
        ({ commands }) =>
          commands.insertContent({
            type: this.name,
            attrs: attributes,
          }),
      unsetVideo:
        () =>
        ({ commands }) =>
          commands.deleteSelection(),
    };
  },
});

export default LegacyVideo;
